export default __webpack_public_path__ + "img/contact-banner.asset.ef3d2364.jpg";